import React from 'react';

/**
 * Status bar at the bottom of the add-in.
 * Shows connection status (pulsing teal dot) and version.
 * @param {{ label: string }} props
 */
export default function StatusBar({ label }) {
    return (
        <div className="status-bar">
            <div className="status-dot">
                <div className="dot" />
                <span>{label}</span>
            </div>
            <div className="status-ver">v2.0</div>
        </div>
    );
}
